import React from 'react';
import { Switch } from 'react-router-dom';

import ErrorBoundaryRoute from 'app/shared/error/error-boundary-route';


import TireTruckImplementCustom from 'app/modules/tire-custom/tire-truckImplement-custom/tire-truck-implement-custom';
import TireTruckImplementCustomUpdate from 'app/modules/tire-custom/tire-truckImplement-custom/tire-truck-implement-custom-update';
import TireGrooveCustomUpdate from 'app/modules/tire-custom/tire-groove-custom/tire-groove-custom-update';

const Routes = ({ match }) => (
  <>
    <Switch>

      <ErrorBoundaryRoute exact path={`${match.url}/tire-truck-implement-custom/:truckImplementId`} component={TireTruckImplementCustom} />
      <ErrorBoundaryRoute exact path={`${match.url}/tire-truck-implement-custom-update/:truckImplementId`} component={TireTruckImplementCustomUpdate} />
      <ErrorBoundaryRoute exact path={`${match.url}/groove-measurement-update/:truckImplementId`} component={TireGrooveCustomUpdate} />

    </Switch>

  </>
);

export default Routes;
